import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="grid min-h-[60dvh] place-items-center text-center">
      <div>
        <div className="mx-auto grid size-12 place-items-center rounded-xl bg-elevated text-muted">
          <Compass aria-hidden="true" className="size-5" />
        </div>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-accent">404</p>
        <h1 className="mt-2 font-display text-3xl font-bold">Diese Seite gibt es nicht</h1>
        <p className="mt-2 text-sm text-muted">Deine lokalen Daten sind davon nicht betroffen.</p>
        <Link className={`${buttonVariants()} mt-5`} to="/today">
          Zur Heute-Seite
        </Link>
      </div>
    </div>
  );
}
